import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import trendingVenues from '../../data/trendingVenues.js';
import VenueCard from '../Cards/VenueCard';
import PrimaryBtn from '../Buttons/PrimaryBtn';
import { Navigation, Pagination, Autoplay, Mousewheel } from 'swiper/modules';

export default function TrendingVenues() {
    return (
        <div className="happening-events-container">
            <Swiper
                spaceBetween={0}
                slidesPerView={3.6}
                centeredSlides={true}
                loop={true}
                autoplay={{
                    delay: 4500,
                    disableOnInteraction: false
                }}
                navigation={true}
                mousewheel={true}
                pagination={{ clickable: true }}
                modules={[Navigation, Pagination, Autoplay, Mousewheel]}
                className="happening-events"
            >
                {trendingVenues.map((venue, index) => (
                    <SwiperSlide key={index} className="swiper-slide">
                        <VenueCard />
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className="explore-all-btn">
                <PrimaryBtn name="Explore All" />
            </div>
        </div>
    );
}
